import { createTestIds } from '@duke-hq/lib/createTestId';

export const testIds = createTestIds(
  'apps-admin-web-components-ReactFlow-nodes-FlowEditorBlockNode',
  [
    'node',
    'nodeTitleInput',
    'addOptionButton',
    'deleteOptionButton',
    'addObjectHandle',
    'nodeActionsButton',
    'addNodeButton',
  ],
);
